function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5326 0H1.46739C0.658247 0 0 0.599279 0 1.33594V17.6641C0 18.4007 0.658247 19 1.46739 19H13.5326C14.3418 19 15 18.4007 15 17.6641V1.33594C15 0.599279 14.3418 0 13.5326 0ZM4.23913 6.82812H10.7609C11.121 6.82812 11.413 7.09398 11.413 7.42188C11.413 7.74977 11.121 8.01562 10.7609 8.01562H4.23913C3.87897 8.01562 3.58696 7.74977 3.58696 7.42188C3.58696 7.09398 3.87897 6.82812 4.23913 6.82812ZM3.58696 10.3906C3.58696 10.0627 3.87897 9.79688 4.23913 9.79688H10.7609C11.121 9.79688 11.413 10.0627 11.413 10.3906C11.413 10.7185 11.121 10.9844 10.7609 10.9844H4.23913C3.87897 10.9844 3.58696 10.7185 3.58696 10.3906ZM11.087 15.7344H9.78261C9.42245 15.7344 9.13043 15.4685 9.13043 15.1406C9.13043 14.8127 9.42245 14.5469 9.78261 14.5469H11.087C11.4471 14.5469 11.7391 14.8127 11.7391 15.1406C11.7391 15.4685 11.4471 15.7344 11.087 15.7344Z",
  fill: "#072E4B"
});

var SvgBasicinfo = function SvgBasicinfo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBasicinfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/basicinfo.7ee0be43.svg";
export { ForwardRef as ReactComponent };